// extracted by mini-css-extract-plugin
export default {"container":"relatorsrightside_container__JBVIn","box":"relatorsrightside_box__+K5HW","banner":"relatorsrightside_banner__z7WLC","post":"relatorsrightside_post__kkfXc"};